import { combineEpics } from 'redux-observable'

import agentEpics from '~/agent/store/agent.epics'
import bundlesEpics from '~/bundles/store/bundles.epics'
import checkoutEpics from '~/checkout/store/checkout.epics'
import contractEpics from '~/contract/store/contract.epics'
import customerEpics from '~/customer/store/customer.epics'
import legalEpics from '~/legal/store/legalTexts/legalTexts.epics'
import nextStepsEpics from '~/legal/store/nextSteps/nextSteps.epics'
import lineEpics from '~/line/store/line.epics'
import masterDataEpics from '~/masterData/store/masterData.epics'
import paymentsEpics from '~/payments/store/payments.epics'
import tariffEpics from '~/tariff/store/tariff.epics'

const rootEpic = combineEpics(
  ...Object.values(agentEpics),
  ...Object.values(lineEpics),
  ...Object.values(tariffEpics),
  ...Object.values(masterDataEpics),
  ...Object.values(checkoutEpics),
  ...Object.values(legalEpics),
  ...Object.values(bundlesEpics),
  ...Object.values(nextStepsEpics),
  ...Object.values(customerEpics),
  ...Object.values(contractEpics),
  ...Object.values(paymentsEpics),
)

export type RootEpic = typeof rootEpic

export default rootEpic
